import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2023project/q4/2024economics/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getVoteList = (type: any, page: number) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      awards: type,
      page,
    },
  });
};
const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};
const getNews = (page: any, classId: any) => {
  return http.get(`/v1/news/topicList?page=${page}&classId=${classId}`);
};

const getNewsTwo = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};


const getRules = (type: any) => {
  const data: any = {
    1: `<p style="text-align: justify">为庆祝中华人民共和国成立75周年，深入学习贯彻党的二十届三中全会精神、习近平总书记视察重庆重要讲话重要指示精神、以及市委六届六次会议和市委常委会扩大会议精神，推动完善中国特色现代企业制度，弘扬企业家精神，支持和引导全市各类企业提高资源要素利用效率和经营管理水平、履行社会责任，推进加快建设更多世界一流企业。重庆日报报业集团创新推出“重庆经济人物新发现”主题宣传活动。</p>
    <p>本次活动将着力展现推动重庆高质量发展取得的新成就，推动人民生活水平显著提升的新作为。挖掘、宣传在巩固拓展“三攻坚一盘活”改革突破成果，因地制宜发展新质生产力，做强做大“33618”现代制造业集群体系，促进实体经济和数字经济深度融合，发展现代服务业等方面做出积极贡献和显著成绩的领军人物和优秀案例。</p>
    <p>通过本次活动，为重庆奋力打造新时代西部大开发重要战略支点、内陆开放综合枢纽，加快建设全面深化改革先行区，努力形成更多“西部领先、全国进位和重庆辨识度”的标志性改革成果，奋力谱写中国式现代化重庆篇章营造良好舆论氛围。</p>`,
    2: `<p>1.指导单位</p>
<p>重庆市委组织部、重庆市委宣传部、重庆市委统战部</p>
<p>2.主办单位</p>
<p>重庆日报报业集团、重庆两江新区管委会</p>
<p>3.承办单位</p>
<p>上游新闻、两江新区党工委宣传部、两江新区党工委统战部</p>
<p>4.协办单位</p>
<p>华龙网集团</p>
<p>5.组委会成员单位</p>
<p>重庆市委金融办、重庆市发展改革委、重庆市科技局、重庆市经济信息委、重庆市人力社保局、重庆市规划自然资源局、重庆市住房城乡建委、重庆市城市管理局、重庆市交通运输委、重庆市农业农村委、重庆市商务委、重庆市文化旅游委、重庆市国资委、重庆市大数据发展局、重庆市工商联</p>
<p>6. 特别支持</p>
<p>中国电信重庆公司</p>`,
    3: `<p>（一）人物类</p>
    <p>2023重庆经济年度人物</p>
    <p>2023重庆经济年度创新人物</p>
    <p>2023两江新区经济年度人物</p>
    <p>（二）案例类</p>
    <p>2023成渝地区双城经济圈协同发展创新案例</p>
    <p>2023重庆经济改革创新案例</p>`,
    4: `<p>为进一步全面深化改革，主动服务和融入新发展格局，着力推动高质量发展，建设现代化新重庆作出积极贡献；全力打造“西部领先、全国进位和重庆辨识度”标志性改革成果；加快成渝地区区域市场一体化、深度融入全国统一大市场，激发全社会内生动力和创新活力。</p>
    <p>1.人物类</p>
    <p>（1）基本条件</p>
    <p>① 遵守国家法律，坚持正确政治方向，践行社会主义核心价值观，具有良好的职业道德和行业声誉；</p>
    <p>② 在爱国、创新、诚信、社会责任和国际视野等方面不断提升自己，推动企业发挥更大作用实现更大发展；</p>
    <p>③ 具备良好的风险管控能力，个人及所在单位无不良会计信用、纳税信用和银行信用记录及其他违规违法行为，近三年内无重大安全、质量、环境污染事故及重大劳资领域纠纷发生；</p>
    <p>④ 2023年度在同一单位担任董事长、总裁、总经理等主要领导职务；</p>
    <p>⑤“重庆经济年度人物”和“重庆经济年度创新人物”不得重复参与。</p>
    <p>（2）具体条件</p>
    <p>①“重庆经济年度人物”所在单位是在重庆注册的法人企业并开展业务，企业注册时间为2021年1月1日前，近三年保持盈利，在创造产值、税收贡献、扩大就业、行业引领、产业升级等方面有突出表现。企业2023年主营收入5亿元以上，纳税金额3000万元以上，就业人数300人以上。其中，农业、服务业企业2023年主营收入2亿元以上，纳税金额300万元以上，就业人数200人以上。</p>
    <p>②“重庆经济年度创新人物”所在单位是在重庆注册的法人企业并开展业务，企业注册时间为2023年1月1日前，在业态创新、数字化运营、模式创新、技术创新等方面有突出表现。2023年营业收入3000万元以上。年度研发经费投入不低于100万元，研发经费投入强度不低于3%，农业、非高技术服务业创新企业，曾参与行业标准制定或具有核心技术发明专利，可适当放宽研发经费投入条件。</p>
    <p>③“两江新区经济年度人物”所在单位是在两江新区注册的法人企业并开展业务，企业注册时间为2023年1月1日前，在加快构建现代化产业体系、提升科技创新支撑能力、提振信心加快扩大内需、着力推动区域协调发展、持续推动营商环境优化、加快推动城市品质提升等方面在两江新区及重庆有突出表现。2023年营业收入1亿元以上，纳税金额500万元以上，就业人数100人以上。</p>
    <p>④“西部领先、全国进位和重庆辨识度”标志性改革成果特别突出者可适当放宽条件。</p>
    <p>2.案例类</p>
    <p>（1）“成渝地区双城经济圈协同发展创新案例”在聚焦唱好新时代西部“双城记”，抓好“十项行动”和重点任务清单，纵深推进成渝地区双城经济圈建设，在加快构建双城经济圈发展新格局、合力建设现代基础设施网络、协同建设现代产业体系、共建具有全国影响力的科技创新中心、共同打造富有巴蜀特色的国际消费目的地、共筑长江上游生态屏障、联手打造内陆改革开放综合枢纽、共同推动城乡融合发展、推动公共服务共建共享、加强规划实施保障、共建西部金融中心等方面涌现出的新机制、新模式、新成果，政府部门及企业均可报名参与。</p>
    <p>（2）“重庆经济改革创新案例”在加快推动重庆高质量发展中，推进重要领域和关键环节改革创新突破、落地见效。聚焦打造新时代西部大开发重要战略支点、内陆开放综合枢纽，服务构建高水平社会主义市场经济体制，巩固拓展“三攻坚一盘活”改革突破成果，推动民营经济高质量发展，因地制宜发展新质生产力，做强做大“33618”现代制造业集群体系，促进实体经济和数字经济深度融合，发展现代服务业，支持全面创新人才发展，超大城市现代化治理，城乡融合发展等方面涌现出的可复制推广的新机制、新模式、新成果，政府部门及企业均可报名参与。</p>
    `,
    5: `<p>1.经济贡献力</p>
    <p>2.创新变革力</p>
    <p>3.行业带动力</p>
    <p>4.持续发展力</p>
    <p>5.社会影响力</p>`,
    6: `<p>1.广泛征集</p>
<p style="text-align: left;">备注：每5年（2020—2024年）为一个推荐周期，5年内相同类别只推荐一次。</p>
<p>2. 入围审查</p>
<p>3. 公众点赞</p>
<p>4. 专家评审</p>
<p>5. 终审公示</p>
<p>6. 表彰颁奖</p>`,
  };
  return data[type];
};
// 人物
const vote = (page: number, search: string) => {
  return http.get(
    `vote/2023project/q4/2024economics_vote/controller.php?enews=vote-list&search=${search}&page=${page}`,
  );
};
// 案例
const caseVote = (page: number, search: string) => {
  return http.get(
    `vote/2023project/q4/2024economics_case_vote/controller.php?enews=vote-list&search=${search}&page=${page}`,
  );
};
const voteDetail = (id: string) => {
  return http.get(
    `vote/2023project/q4/2024economics_vote/controller.php?enews=detail&id=${id}`,
  );
};
const caseDetail = (id: string) => {
  return http.get(
    `vote/2023project/q4/2024economics_case_vote/controller.php?enews=detail&id=${id}`,
  );
};
export {
  getBaseInfo,
  getVoteList,
  getRules,
  getDetail,
  getNews,
  vote,
  caseVote,
  voteDetail,
  caseDetail,
  getNewsTwo,
};
